<div class="finance-modal-header">
  <div class="title-block">
    <mat-icon *ngIf="icon" class="title-icon">{{ icon }}</mat-icon>
    <h2>{{ title }}</h2>
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()" [attr.aria-label]="closeAriaLabel">
    <mat-icon>close</mat-icon>
  </button>
</div>
